import { Gender } from '../../api';
import { TITLES_GENDER } from '../../config';

interface IFormatUserNameParams {
  firstName: string;
  lastName: string;
  gender: Gender;
  middleName?: string;
}

export const formatUserName = ({ firstName, lastName, gender }: IFormatUserNameParams) => {
  return `${gender && gender !== Gender.Other ? `${TITLES_GENDER[gender]} ` : ''}${firstName} ${lastName}`
}